/* import __COLOCATED_TEMPLATE__ from './profile-avatar.hbs'; */
import Component from '@glimmer/component';
/**
 * Component meant to render profile avatars based on passed initials.  Custom styling can be applied via the containerClass argument.
 *
 * Initials can be styled via the backgroundColor/initialsColor argument (useful for applying colors coming from the server).
 * If these properties are omit, then colors need to be applied through the containerClass argument.
 */
export default class ProfileAvatar extends Component {
  get containerClass() {
    return this.args.containerClass ?? '';
  }
  get dynamicContainerStyles() {
    if (!this.args.backgroundColor) {
      return '';
    }
    return `
      background-color: ${this.args.backgroundColor}
    `;
  }
  get dynamicInitialsStyles() {
    if (!this.args.initialsColor) {
      return '';
    }
    return `
      color: ${this.args.initialsColor}
    `;
  }
}